import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PlanPermissionsProvider } from "../context/PlanPermissions/PlanPermissionsContext";
import { CompaniesProvider } from "../context/Companies/CompaniesContext";
import { PlansProvider } from "../context/Plans/PlansContext";
import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import HelpCenter from "../pages/HelpCenter";
import HelpCategory from "../pages/HelpCenter/Category";
import HelpArticle from "../pages/HelpCenter/Article";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import Wallets from "../pages/Wallets/";
import QuickMessages from "../pages/QuickMessages/";
import { AuthProvider } from "../context/Auth/AuthContext";
import { SettingsProvider } from "../context/Settings/SettingsContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { CompanySettingsProvider } from "../context/CompanySettings/CompanySettingsContext";
import { AsteriskProvider } from "../context/Asterisk/AsteriskContext";
import CustomRoute from "./CustomRoute";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AllConnections from "../pages/AllConnections/";
import Reports from "../pages/Reports";
import RelatorioVendas from "../pages/RelatorioVendas";
import Subscription from "../pages/Subscription/";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files/";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import BirthdaySettingsPage from "../pages/BirthdaySettings";
import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import FlowBuilder from "../pages/FlowBuilder";
import FlowDefault from "../pages/FlowDefault";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import Assistant from "../pages/Assistants";
import SDRDashboard from "../pages/SDR";
import SDRLeads from "../pages/SDR/Leads";
import LandingPageEditor from "../pages/LandingPages/Editor";
import PublicLandingPage from '../pages/LandingPages/Public';
import LandingPagesList from "../pages/LandingPages/List";
import Groups from "../pages/Groups";
import AsteriskConnections from "../pages/Asterisk";
import AsteriskCallHistory from "../pages/AsteriskManagement/AsteriskCallHistory";
import AsteriskEndpoints from "../pages/AsteriskManagement/AsteriskEndpoints";
import UTMLinkGenerator from "../pages/UTMLinkGenerator";
import UTMDashboard from "../pages/UTMDashboard";
import Catalog from "../pages/Catalog";

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <PlanPermissionsProvider>
          <CompanySettingsProvider>
            <CompaniesProvider>
              <PlansProvider>
                <SettingsProvider>
                  <TicketsContextProvider>
                <Switch>
                  <CustomRoute exact path="/l/:companyId/:slug" component={PublicLandingPage} />
                  <CustomRoute exact path="/login" component={Login} />
                  <CustomRoute exact path="/signup" component={Signup} />

                  <LoggedInLayout>
                    <WhatsAppsProvider>
                      <AsteriskProvider>
                        <CustomRoute
                          exact
                          path="/financeiro"
                          component={Financeiro}
                          isPrivate
                        />

                        <CustomRoute
                          exact
                          path="/landing-pages/edit/:id"
                          component={LandingPageEditor}
                          isPrivate
                        />

                        <CustomRoute
                          exact
                          path="/financeiro-aberto"
                          component={Financeiro}
                          isPrivate
                        />

                        <CustomRoute
                          exact
                          path="/birthday-settings"
                          component={BirthdaySettingsPage}
                          isPrivate
                        />
                        <CustomRoute exact path="/" component={Dashboard} isPrivate />
                        <CustomRoute
                          exact
                          path="/tickets/:ticketId?"
                          component={TicketResponsiveContainer}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/connections"
                          component={Connections}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/quick-messages"
                          component={QuickMessages}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/schedules"
                          component={Schedules}
                          isPrivate
                        />
                        <CustomRoute exact path="/tags" component={Tags} isPrivate />
                        <CustomRoute exact path="/contacts" component={Contacts} isPrivate />
                        <CustomRoute
                          exact
                          path="/contacts/import"
                          component={ContactImportPage}
                          isPrivate
                        />
                        <CustomRoute exact path="/wallets" component={Wallets} isPrivate />
                        <CustomRoute exact path="/help" component={HelpCenter} isPrivate />
                        <CustomRoute exact path="/help/article/:slug" component={HelpArticle} isPrivate />
                        <CustomRoute exact path="/help/:slug" component={HelpCategory} isPrivate />
                        <CustomRoute exact path="/users" component={Users} isPrivate />
                        <CustomRoute
                          exact
                          path="/messages-api"
                          component={MessagesAPI}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/settings"
                          component={Settings}
                          isPrivate
                        />
                        <CustomRoute exact path="/landing-pages" component={LandingPagesList} isPrivate />
                        <CustomRoute exact path="/groups" component={Groups} isPrivate />
                        <CustomRoute exact path="/asterisk/connections" component={AsteriskConnections} isPrivate />
                        <CustomRoute exact path="/asterisk/calls" component={AsteriskCallHistory} isPrivate />
                        <CustomRoute exact path="/asterisk/endpoints" component={AsteriskEndpoints} isPrivate />
                        <CustomRoute exact path="/queues" component={Queues} isPrivate />
                        <CustomRoute exact path="/reports" component={Reports} isPrivate />
                        <CustomRoute
                          exact
                          path="/relatorio-vendas"
                          component={RelatorioVendas}
                          isPrivate
                        />
                        <CustomRoute exact path="/utm/generator" component={UTMLinkGenerator} isPrivate />
                        <CustomRoute exact path="/utm/dashboard" component={UTMDashboard} isPrivate />
                        <CustomRoute exact path="/catalog" component={Catalog} isPrivate />
                        <CustomRoute
                          exact
                          path="/queue-integration"
                          component={QueueIntegration}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/announcements"
                          component={Annoucements}
                          isPrivate
                        />
                        <CustomRoute exact path="/chats/:id?" component={Chat} isPrivate />
                        <CustomRoute exact path="/files" component={Files} isPrivate />
                        <CustomRoute
                          exact
                          path="/moments"
                          component={ChatMoments}
                          isPrivate
                        />
                        <CustomRoute exact path="/Kanban" component={Kanban} isPrivate />
                        <CustomRoute
                          exact
                          path="/TagsKanban"
                          component={TagsKanban}
                          isPrivate
                        />
                        <CustomRoute exact path="/prompts" component={Prompts} isPrivate />
                        <CustomRoute
                          exact
                          path="/allConnections"
                          component={AllConnections}
                          isPrivate
                        />

                        <CustomRoute
                          exact
                          path="/phrase-lists"
                          component={CampaignsPhrase}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/flowbuilders"
                          component={FlowBuilder}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/flowbuilder/:id?"
                          component={FlowBuilderConfig}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/assistants"
                          component={Assistant}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/sdr"
                          component={SDRDashboard}
                          isPrivate
                        />
                        <CustomRoute
                          exact
                          path="/sdr/campaigns/:campaignId/leads"
                          component={SDRLeads}
                          isPrivate
                        />

                        {showCampaigns && (
                          <>
                            <CustomRoute
                              exact
                              path="/contact-lists"
                              component={ContactLists}
                              isPrivate
                            />
                            <CustomRoute
                              exact
                              path="/contact-lists/:contactListId/contacts"
                              component={ContactListItems}
                              isPrivate
                            />
                            <CustomRoute
                              exact
                              path="/campaigns"
                              component={Campaigns}
                              isPrivate
                            />
                            <CustomRoute
                              exact
                              path="/campaign/:campaignId/report"
                              component={CampaignReport}
                              isPrivate
                            />
                            <CustomRoute
                              exact
                              path="/campaigns-config"
                              component={CampaignsConfig}
                              isPrivate
                            />
                          </>
                        )}
                      </AsteriskProvider>
                    </WhatsAppsProvider>
                  </LoggedInLayout>

                </Switch>
                <ToastContainer
                  position="top-right"
                  autoClose={4000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                  toastClassName="custom-toast"
                  bodyClassName="custom-toast-body"
                  progressClassName="custom-progress-bar"
                  closeButton={true}
                />
              </TicketsContextProvider>
            </SettingsProvider>
          </PlansProvider>
        </CompaniesProvider>
      </CompanySettingsProvider>
    </PlanPermissionsProvider>
  </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
